<template>
  <div 
    :class="{'hotmart-pro': topBarConfig.user.ucode}"
    class="searchbar-user">
    <div class="container no-padding">
      <div class="title">
        <i class="fa icon-kp-mail" aria-hidden="true"></i>
        {{ $t('account.header.title') }}
      </div>
      <div class="subtitle">
        {{ $t('account.header.subtitle') }}
      </div>
      <div class="dataTables_filter search-flex">
        <label>
          <input class="kp-input-search" :placeholder="$t('account.header.searchAccount')" type="text">
          <span class="filter_search icon-search">
            <i class="fa fa-search"></i>
          </span>
        </label>
        <div class="kp-filter-action">
          <a class="none-mobile pull-right kp-button"
             @click="modalOpen('edit-account');
             resetActiveAccount();">
            <span class="icon-kp-plus"></span>{{ $t('account.actions.new') }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  computed: mapGetters({
    topBarConfig: 'topBar/config',
  }),
  methods: mapActions({
    modalOpen: 'modal/open',
    resetActiveAccount: 'account/resetActive',
  }),
};
</script>



// WEBPACK FOOTER //
// MailServiceHeader.vue?1eb010ac